import { AfterViewInit, ChangeDetectorRef, Directive, EventEmitter, Output } from '@angular/core';

@Directive()
export class ListDirective implements AfterViewInit {
    @Output() loadData = new EventEmitter();

    constructor(public changeDetection: ChangeDetectorRef) {}

    ngAfterViewInit() {
        this.changeDetection.detectChanges();
    }
}
